// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1hxSg","rightAdornment":"Header_rightAdornment__3FLeN"};